exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.list-panel[data-v-0e4b1b76] {\n  border: 1px solid #000;\n  height: 300px;\n  overflow-y: scroll;\n}\n.list-panel[data-v-0e4b1b76] .v-input__slot {\n  margin-bottom: 0;\n}\n", ""]);

